import { Layout, Skeleton } from "../../components/ui";
import { useDeleteInventory, useGetInventoryById } from "../../query/inventoryQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import InventoryProfile from "./InventoryProfile";

function InventoryDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: item } = useGetInventoryById(id);
  const { mutate: deleteInventory } = useDeleteInventory();

  const handleDelete = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this inventory item?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) return;
      deleteInventory(id, {
        onSuccess: () => {
          swal("Success", "Inventory item deleted successfully", "success");
          navigate("/inventory");
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete inventory item", "error");
        },
      });
    });
  };

  return (
    <Layout className="configuration">
      <div
        className="boxDetails"
        style={{ background: "transparent", padding: 0, boxShadow: "none" }}
      >
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && item && <InventoryProfile item={item} onDelete={handleDelete} />}
      </div>
    </Layout>
  );
}

export default InventoryDetails;
